export const skills = [
  "Cleaning",
  "Construction",
  "Cooking",
  "Decorating",
  "Dog walking",
  "Eco food",
  "Eco travel",
  "Electrician",
  "Furnature assembily",
  "Gardening",
  "Hanging and mounting",
  "Home removals",
  "Hospitality",
  "Plumbing",
  "Textiles",
  "Waste Removals",
  "Window cleaning",
];



// WEBPACK FOOTER //
// ./src/Constants/taskers.js